module.exports = __webpack_public_path__ + "static/img/manual-4.c16b86f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-4.png
// module id = riX1
// module chunks = 4